import type { TokenType } from "@/features/bridge/types/token-selector.types";
import { create } from "zustand";

interface TokenManagerStore {
  // Currently selected token type
  currentlySelectedTokenType: TokenType | null;
  setCurrentlySelectedTokenType: (val: TokenType) => void;
}

export const useTokenManagerStore = create<TokenManagerStore>((set) => ({
  currentlySelectedTokenType: null,
  setCurrentlySelectedTokenType: (val: TokenType) =>
    set({ currentlySelectedTokenType: val }),
}));
